import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./emptyState.html";
class EmptyStateComponent extends LightningElement {
  constructor(...args) {
    super(...args);
    this.imgSrc = void 0;
    this.alt = '';
    // Image height (any CSS length string accepted by `ax-image`'s height prop).
    this.imgHeight = '354px';
    this.label = void 0;
    // Type-style applied to the label. Defaults to `body-2` so existing consumers render
    // unchanged. Pass a heading-grade utility (e.g. `display-7`) for prominent empty-state
    // headlines.
    this.labelTypeStyle = 'body-2';
    this.description = void 0;
    this.ctaLabel = void 0;
    this.ctaHref = void 0;
  }
  handleCtaClick() {
    const event = new CustomEvent('ctaclick');
    this.dispatchEvent(event);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(EmptyStateComponent, {
  publicProps: {
    imgSrc: {
      config: 0
    },
    alt: {
      config: 0
    },
    imgHeight: {
      config: 0
    },
    label: {
      config: 0
    },
    labelTypeStyle: {
      config: 0
    },
    description: {
      config: 0
    },
    ctaLabel: {
      config: 0
    },
    ctaHref: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(EmptyStateComponent, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;